const projectData = [
    {
        img: '',
        title: 'Movie-Success-Predictor Desktop App',
        team: ['Rounak Hazra', 'Abesh Biswas', 'Mayukh Bhowmick'],
        url: '',
        description: 'A Desktop Application that predicts Upcoming Hollywood Movies to be hit, average, flop by analyzing performance of actors and directors based on their past movies',
        repoLink: 'https://www.github.com/',
    },
    {
        img: '',
        title: 'Expense-Tracker',
        team: ['Mayukh Bhowmick'],
        url: '',
        description: 'React-Expense-Tracker can that can Add new Expense, Delete an Expense, Update an existing Expense : Date/Item name/Price',
        repoLink: 'https://github.com/mayukh551/Expense-Tracker-React',
    },
    {
        img: '',
        title: 'Regalia 2022 website',
        team: ['Soham Saha Roy'],
        url: '',
        description: 'A website for Regalia which is the cultural fest of our College',
        repoLink: 'https://github.com/infuman69/regalia-2022-backend',
    },
    {
        img: '',
        title: 'Icecream-Store',
        team: ['Rounak Hazra'],
        url: '',
        description: 'An Icecream-store full stack website for owner-customer interactions.',
        repoLink: 'https://www.github.comhttps://github.com/CoderRounak/icecream-store',
    },
    {
        img: '',
        title: 'roBot',
        team: ['Soham Banerjee', 'Sourya Sekhar', 'Soham Sarkar'],
        url: '',
        description: 'A discord Bot for RCCTechz Discord Server',
        repoLink: 'https://github.com/RccTechz/roBOT',
    },
    {
        img: '',
        title: 'Invenotry-Item-Management',
        team: ['Mayukh Bhowmick'],
        url: '',
        description: 'this website allow user to add, delete, edit items in the inventory; Filter and sort exisitng items; View items in list or gallery form',
        repoLink: 'https://www.github.com',
    },
    {
        img: '',
        title: 'W-ambulance',
        team: ['Aritra Belel'],
        url: '',
        description: "As in emergency it's quite hard to search for an ambulance, hospital in google or to download new health related apps from PlayStore/ Appstore.Also nowadays almost everyone have a Whatsapp account, so we thought to build a WhatsApp Bot which will arrange Ambulance in no time.",
        repoLink: 'https://github.com/belelaritra/W-ambulance',
    },
    {
        img: '',
        title: 'Graphical Password Authentication System',
        team: ['Nirnaya Betal', 'Priti Sen', 'Soham Saha Roy'],
        url: '',
        description: 'A Graphical Password Authentication system is an authentication system that uses some combination of graphical images replacing the regular passwords. Graphical passwords may offer better security than text-based passwords because most of the people use regular, popular passwords everywhere and are prone to social engineering attacks. So graphical passwords can put stop to many attacks of this kind.',
        repoLink: 'https://github.com/infuman69/Graphical-Password-Authentication',
    },
    {
        img: '',
        title: 'FoodieApp',
        team: ['Nishant Thakur', 'Suryasnata Saha'],
        url: '',
        description: 'N/A',
        repoLink: 'https://github.com/Nishantthakur62/FoodieApp',
    },
    {
        img: '',
        title: 'Typing Practice Website',
        team: ['Mayukh Bhowmick'],
        url: '',
        description: 'A website for improving your typing speed',
        repoLink: 'https://github.com/mayukh551/Typing_Practice-Website',
    },
]

export default projectData;